import { CourseStoreState } from './state';
import * as actionTypes from './types';
import { ENROLLED_LIST, UPDATE_COURSES, DELETE_INSTRUCTOR_COURSE } from './types';
import { normalize } from 'normalizr';
import * as schema from '../../utils/schema';

export default function user(state = CourseStoreState, action: any) {

  switch (action.type) {
    case actionTypes.FETCH_PROGRAM_LIST:
      return {
        programList: action.payload
      }

    case actionTypes.COURSES:
      let coursesFilter = action.payload.content.filter((course: any) => {
        if (!state.result.find((item: any) => {
          return course.id === item
        })) {
          return course;
        }
      });
      let courseChanges = normalize(coursesFilter, [schema.courses]);
      return {
        ...state,
        result: state.result.concat(courseChanges.result),
        courses: Object.assign((state.courses || []), courseChanges.entities.courses),
        totalCoursesNo: action.payload.totalCourses
      };

    case actionTypes.EACH_COURSES:
      let coursesEachFilter = action.payload.filter((course: any) => {
        if (!state.result.find((item: any) => {
          return course.id === item
        })) {
          return course;
        }
      });
      let courseEachChanges = normalize(coursesEachFilter, [schema.courses]);
      return {
        ...state,
        result: state.result.concat(courseEachChanges.result),
        courses: Object.assign((state.courses || []), courseEachChanges.entities.courses),
        totalCoursesNo: action.payload.totalCourses
      };

    case actionTypes.FETCH_MODULE:
      action.payload.moduleDetails.map((moduleDet: any, index: number) => {
        moduleDet.units = [...moduleDet.units, ...moduleDet.moduleProjectId];
        moduleDet.moduleIndex = index + 1;
        return moduleDet;
      })

      let moduleChanges = normalize(action.payload.moduleDetails, [schema.modules]);
      return {
        ...state,
        modules: Object.assign((state.modules || []), moduleChanges.entities.modules),
        units: Object.assign((state.units || []), moduleChanges.entities.unitDetails),
      };

    case actionTypes.FETCH_UNIT:
      let chapterList: any = [];
      action.payload.unitDetails.map((unit: any) => {
        let chapterDetails = unit.chapters.map((chapter: any) => {
          chapter.type = 'chapter';
          chapter.unitId = unit.id;
          return chapter;
        });
        const assignmentDetails = unit.assignments.map((chapter: any, index: number) => {
          chapter.type = 'assignment';
          chapter.unitId = unit.id;
          return chapter;
        });

        chapterDetails = [...chapterDetails, ...assignmentDetails];


        unit.type = 'unit';
        chapterList = [...chapterDetails, ...chapterList];
        return (chapterList);
      });
      const chapterNormalize = normalize(chapterList, [schema.chapter]);

      action.payload.moduleProject.map((project: any) => {
        project.type = 'project';
      });

      const moduleProject = normalize(action.payload.moduleProject, [schema.unit]);
      return {
        ...state,
        // chapters: Object.assign((state.chapters || []), chapterNormalize.entities.chapters)
        chapters: {
          ...state.chapters,
          ...chapterNormalize.entities.chapters,
        },
        videos: {
          ...state.videos,
          ...chapterNormalize.entities.videos
        },
        units: {
          ...state.units,
          ...moduleProject.entities.unitDetails
        }
      }

    case actionTypes.COURSES_ENROLLED_LIST:
      let enrollFilter = action.payload.filter((course: any) => {
        if (!state.result.find((item: any) => {
          return course.id === item
        })) {
          return course;
        }
      });
      let enrollledList = normalize(enrollFilter, [schema.courses]);
      return {
        ...state,
        result: state.result.concat(enrollledList.result),
        courses: Object.assign((state.courses || []), enrollledList.entities.courses),
        videos: Object.assign((state.videos || {}), enrollledList.entities.videos),
        resources: Object.assign((state.resources || {}), enrollledList.entities.resources),
        notes: Object.assign((state.notes || {}), enrollledList.entities.notes),
        chapters: Object.assign((state.chapters || {}), enrollledList.entities.chapters),
        units: Object.assign((state.units || {}), enrollledList.entities.units),
      };

    case actionTypes.COURSES_PENDING_LIST:
      let pendingFilter = action.payload.filter((course: any) => {
        if (!state.result.find((item: any) => {
          return course.id === item
        })) {
          return course;
        }
      });
      let pendingList = normalize(pendingFilter, [schema.courses]);
      return {
        ...state,
        result: state.result.concat(pendingList.result),
        courses: Object.assign((state.courses || []), pendingList.entities.courses),
        videos: Object.assign((state.videos || {}), pendingList.entities.videos),
        resources: Object.assign((state.resources || {}), pendingList.entities.resources),
        notes: Object.assign((state.notes || {}), pendingList.entities.notes),
        chapters: Object.assign((state.chapters || {}), pendingList.entities.chapters),
        units: Object.assign((state.units || {}), pendingList.entities.units),
      };

    case actionTypes.COURSES_SEARCH:
      let coursesFil = action.payload.courses.filter((course: any) => {
        if (!state.result.find((item: any) => {
          return course.id === item
        })) {
          return course;
        }
      });
      let ItemCh = normalize(coursesFil, [schema.courses]);
      let ItemSearch = normalize(action.payload.courses, [schema.courses]);
      return {
        ...state,
        result: state.result.concat(ItemCh.result),
        courses: Object.assign((state.courses || []), ItemCh.entities.courses),
        videos: Object.assign((state.videos || {}), ItemCh.entities.videos),
        resources: Object.assign((state.resources || {}), ItemCh.entities.resources),
        notes: Object.assign((state.notes || {}), ItemCh.entities.notes),
        chapters: Object.assign((state.chapters || {}), ItemCh.entities.chapters),
        units: Object.assign((state.units || {}), ItemCh.entities.units),
        totalCoursesNo: action.payload.totalCourses,
        resultSearch: ItemSearch.result,
        coursesSearch: ItemSearch.entities.courses || {},
      };

    case actionTypes.COURSES_SEARCH_LOAD:
      let coursesFilload = action.payload.courses.filter((course: any) => {
        if (!state.result.find((item: any) => {
          return course.id === item
        })) {
          return course;
        }
      });
      if (!coursesFilload.length) {
        return { ...state }
      }
      let ItemChload = normalize(coursesFilload, [schema.courses]);
      let ItemSearchload = normalize(action.payload.courses, [schema.courses]);
      return {
        ...state,
        result: state.result.concat(ItemChload.result),
        courses: Object.assign((state.courses || []), ItemChload.entities.courses),
        videos: Object.assign((state.videos || {}), ItemChload.entities.videos),
        resources: Object.assign((state.resources || {}), ItemChload.entities.resources),
        notes: Object.assign((state.notes || {}), ItemChload.entities.notes),
        chapters: Object.assign((state.chapters || {}), ItemChload.entities.chapters),
        units: Object.assign((state.units || {}), ItemChload.entities.units),
        totalCoursesNo: action.payload.totalCourses,
        resultSearch: state.resultSearch.concat(ItemSearchload.result),
        coursesSearch: Object.assign((state.coursesSearch || []), (ItemSearchload.entities.courses || {}))
      };

    /* case actionTypes.COURSES_PUSH:
      let coursesFilterList = action.payload.courses.filter((course: any) => {
        if(!state.result.find((item: any) => {
          return course.id === item
        })) {
          return course;
        }
      });
      let ItemChangesList = normalize(coursesFilterList, [schema.courses]);
      return {
        ...state,
        result: state.result.concat(ItemChangesList.result),
        courses: Object.assign(state.courses, ItemChangesList.entities.courses),
        videos: Object.assign(state.videos, ItemChangesList.entities.videos),
        chapters: Object.assign(state.chapters, ItemChangesList.entities.chapters),
        units: Object.assign(state.units, ItemChangesList.entities.units),
        totalCoursesNo: action.payload.totalCourses
      }; */

    case actionTypes.COURSES_NOT_FOUND:
      let ChangesItem = normalize(action.payload, [schema.courses]);
      return {
        ...state,
        result: state.result.concat(ChangesItem.result),
        courses: Object.assign((state.courses || []), ChangesItem.entities.courses),
        videos: Object.assign((state.videos || {}), ChangesItem.entities.videos),
        resources: Object.assign((state.resources || {}), ChangesItem.entities.resources),
        notes: Object.assign((state.notes || {}), ChangesItem.entities.notes),
        chapters: Object.assign((state.chapters || {}), ChangesItem.entities.chapters),
        units: Object.assign((state.units || {}), ChangesItem.entities.units)
      };

    case actionTypes.COURSES_INSTRUCTOR:
      return {
        ...state,
        chapters: action.payload.entities.chapters,
        courses: action.payload.entities.courses || [],
        units: action.payload.entities.units,
        videos: action.payload.entities.videos,
        resources: action.payload.entities.resources,
        notes: action.payload.entities.notes,
        result: action.payload.result
      };

    case actionTypes.COURSES_VIEW:
      return {
        ...state,
        chaptersView: action.payload.entities.chapters,
        coursesView: action.payload.entities.courses || [],
        unitsView: action.payload.entities.units,
        videosView: action.payload.entities.videos,
        resourcesView: action.payload.entities.resources,
        notesView: action.payload.entities.notes,
        resultView: action.payload.result
      };

    case actionTypes.CHECK_PROGRESS:
      return {
        ...state,
        startProgress: action.payload
      }

    case actionTypes.COURSES_ERROR:
      return {
        ...state,
        ...action.payload
      };

    // case COURSES_ENROLLED:
    //   return {
    //     ...state
    //   };

    case ENROLLED_LIST:
      return {
        ...state,
        enrolledList: action.payload,
      };

    // case actionTypes.ENROLLMENT_STATUS:
    //   let newStateDetail = Object.assign({}, state);
    //   newStateDetail.courses[action.payload.courseId].enrollmentRequestedUsers.push(action.payload.userId);
    //   return {
    //     ...newStateDetail
    //   };

    case DELETE_INSTRUCTOR_COURSE:
      const newState = Object.assign({}, state);
      if (state.result.length) {
        let indexCourseDelete = state.result.indexOf(action.payload);
        newState.result.splice(indexCourseDelete, 1);
        // newState.courses = delete newState.courses[action.payload];
      }
      return newState;

    case UPDATE_COURSES:
      return {
        ...state,
        courses: {
          ...state.courses,
          ...action.payload.entities.courses
        },
        units: {
          ...state.units,
          ...action.payload.entities.units
        },
        chapters: {
          ...state.chapters,
          ...action.payload.entities.chapters
        },
        videos: {
          ...state.videos,
          ...action.payload.entities.videos
        },
        resources: {
          ...state.resources,
          ...action.payload.entities.resources,
        },
        notes: {
          ...state.notes,
          ...action.payload.entities.notes,
        },
        result: state.result.includes(action.payload.result)
          ? [...state.result]
          : [action.payload.result, ...state.result]
      };

    case actionTypes.FETCH_GRADES:
      return {
        ...state,
        projectGrades: action.payload
      };
    case actionTypes.FETCH_ASSIGNMENT_GRADES:
      return {
        ...state,
        gradesLoading: true,
        assignmentGrades: {}
      };
    case actionTypes.FETCH_ASSIGNMENT_GRADES_SUCCESS:
      return {
        ...state,
        assignmentGrades: action.payload,
        gradesLoading: false
      };

    case actionTypes.FETCH_ASSIGNMENT_GRADES_FAILURE:
      return {
        ...state,
        gradesLoading: false,
        assignmentGrades: {}
      };

    case actionTypes.FETCH_PROGRAM:
      const normalizProgram = normalize(action.payload.content || [], [schema.program]);
      return {
        ...state,
        ...normalizProgram.entities
      };

    case actionTypes.FETCH_OTHER_PROGRAM:
      const otherProgramsN = normalize(action.payload || [], [schema.program]);
      const otherPrograms = otherProgramsN.entities.programs;
      return {
        ...state,
        otherPrograms
      };

    // case actionTypes.UPDATE_CHAPTER:
    //   const chapters = { ...state.chapters };
    //   chapters[action.payload.chapterId].quizDetails = {
    //     ...chapters[action.payload.chapterId].quizDetails,
    //     questionAnswerStates: action.payload.questionAnswerResultDtos
    //   };
    //   return {
    //     ...state,
    //     chapters
    //   };

    case actionTypes.FETCH_PROGRAM_COURSES:
      return {
        ...state
      };

    default:
      return state;
  }
}
